import React from 'react'
import './New3.css';
// import Name from './images/11.jpg'

const New3 = () => {
  return (
    <div className='back1'>
      <h1>Workshop on Flutter & Firebase</h1>
    <h3>Flutter is an app SDK for building high-performance, high-fidelity apps for iOS, Android, web, and desktop from a single codebase.
Firebase is a mobile- and web application development platform, backed by Google, to help developers deliver richer app experiences.

This Workshop was conducted under event coordinators Prashant Shishodia CSE- 1610088 & Harsh Gupta IT-1613104 from date 5th March to 9th March 2019.</h3>
    
  

    </div>
    // <div className="over" style={{background: 'url(${11.jpg})}}
  
      
    

  )
}

export default New3 ;